import axios from '@axios'

export const state = {
  vessels: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allVessels: (state) => state.vessels,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_VESSEL: (state, resp) => {
    if (!resp) return null
    state.vessels = resp.vessels
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_VESSEL: (state, vessel) => {
    state.vessels = state.vessels.filter((w) => w.id !== vessel.id)
  },
}

export const actions = {
  async getVessels({ commit }, params = {}) {
    await axios
      .get('/api/vessels', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_VESSEL', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_VESSEL',
          err.response.status === 404 ? { vessels: [] } : null
        )
      })
  },
  async createVessel({ commit }, vessel) {
    return axios.post(`/api/vessels`, vessel)
  },
  async editVessel({ commit }, vessel) {
    return axios.put(`/api/vessels`, vessel)
  },
  async deleteVessel({ commit }, vessel) {
    await axios.delete(`/api/vessels/${vessel.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_VESSEL', vessel)
      }
    })
  },
}
